import { createResourceCollection } from '@/request'
import { UtilityProgramApplication } from '@/types/utilityProgramApplication'
import { ProgramRequirementProps } from '@/types/utilityProgramProfileEligibility'
import { AppDispatch } from '@/store'

export const utilityProgramApplicationsCollection =
  createResourceCollection<UtilityProgramApplication>({
    name: 'utilityProgramApplications',
    selector: (state) => state.utilityProgramApplications,
    apiConfig: {
      path: 'utility_programs',
    },
  })

export const useHasExistingApplication = (utilityProgramId: number) => {
  const { data } = utilityProgramApplicationsCollection.useFetch(
    `${utilityProgramId}/application_progress`,
  )
  return data.length > 0
}

/**
 * Posts the user's furthest progress to the backend and invalidates the
 * collection so subsequent fetches see the latest state.
 *
 * `current_step` is the index (1-based) of the first incomplete step, so
 * navigating back to an already-completed step does not regress progress.
 */
export const postApplicationProgress = async (
  dispatch: AppDispatch,
  utilityProgramId: number,
  programRequirements: ProgramRequirementProps,
) => {
  const steps = programRequirements.steps
  const firstIncompleteIndex = steps.findIndex((s) => !s.completed)
  const completedAllSteps = firstIncompleteIndex === -1
  const targetStep = completedAllSteps
    ? steps[steps.length - 1]
    : steps[firstIncompleteIndex]
  const currentStep = completedAllSteps
    ? programRequirements.numberOfSteps
    : firstIncompleteIndex + 1
  await dispatch(
    utilityProgramApplicationsCollection.actions.create(
      {
        current_step: currentStep,
        current_step_name: targetStep.name,
        total_steps: programRequirements.numberOfSteps,
      },
      {
        pathSegments: [utilityProgramId.toString(), 'application_progress'],
      },
    ),
  )
  dispatch(utilityProgramApplicationsCollection.actions.invalidate())
}

export default utilityProgramApplicationsCollection.slice.reducer
